<template>
  <g :id="hand.id">
    <template v-if="hand.parent === 'A-22'">
      <path fill="#231F20" d="M72.486,87.0414c1.067,0.2501,1.7292,1.3178,1.4791,2.3848c-0.25,1.067-1.3178,1.7292-2.3848,1.4791
      s-1.7292-1.3178-1.4791-2.3848c0,0,0-0.0001,0.0001-0.0001C70.3516,87.4535,71.4192,86.7914,72.486,87.0414z M71.1405,88.7641
      c-0.1155,0.4929,0.1904,0.986,0.6834,1.1016c0.4929,0.1154,0.986-0.1904,1.1016-0.6834
      c0.1155-0.4927-0.1903-0.9858-0.6829-1.1015c-0.4928-0.1158-0.9861,0.1899-1.1017,0.6827
      C71.1406,88.7636,71.1405,88.7639,71.1405,88.7641z"/>
      <line fill="none" stroke="#231F20" stroke-width="0.5669" stroke-linecap="round" stroke-miterlimit="10" x1="72.0162" y1="86.9886" x2="71.9998" y2="79.0366"/>
    </template>
    <template v-else-if="hand.parent === 'A-36'">
      <path fill="#231F20" d="M73.1914,87.7172c0.5574,0.6565,0.4772,1.6405-0.1792,2.1981c-0.6565,0.5574-1.6405,0.4772-2.1981-0.1793
			c-0.5574-0.6565-0.4772-1.6405,0.1792-2.198c0.0002-0.0002,0.0004-0.0003,0.0006-0.0005
			C71.6505,86.9809,72.6339,87.0614,73.1914,87.7172z M71.5744,88.2218c-0.2784,0.2365-0.3124,0.6539-0.0759,0.9323
			c0.2365,0.2784,0.6539,0.3124,0.9323,0.0759c0.2782-0.2363,0.3124-0.6534,0.0763-0.9318
			c-0.2359-0.2786-0.653-0.3132-0.9316-0.0773C71.5752,88.2212,71.5748,88.2216,71.5744,88.2218z"/>
      <line fill="none" stroke="#231F20" stroke-width="0.5669" stroke-linecap="round" stroke-miterlimit="10" x1="71.9873" y1="87.1674" x2="71.9998" y2="78.8083"/>
    </template>
  </g>
</template>

<script>
export default {
  name: 'sdHandChronoH',
  props: ['data'],
  computed: {
    hand() {
      if (this.data.hand) return this.data.hand;
    },
    watch() {
      if (this.data.watch) return this.data.watch;
    },
  },
};
</script>
